import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Select, Row, Col, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;

const DriversForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [imageFileList, setImageFileList] = useState([]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData, form]);

  const handleImageFileChange = ({ fileList }) => setImageFileList(fileList);

  const uploadFiles = async (url, passengerId) => {
    const formData = new FormData();

    imageFileList.forEach(({ originFileObj }) => {
      formData.append("passengerImage", originFileObj);
    });

    await axios.put(url, formData, {
      headers: { "Content-Type": "multipart/form-data", tenant: "web" },
    });
  };

  const onFinish = async (values) => {
    try {
      let response;

      if (formData.id) {
        // Update driver
        response = await axios.put(
          `http://93.127.203.113:5005/passengers/${formData.id}`,
          values
        );
      } else {
        // Add new driver
        response = await axios.post("http://93.127.203.113:5005/passengers", values);
      }

      if (response?.data?.id) {
        await uploadFiles(
          `http://93.127.203.113:5005/passengers/updateDocuments/${response.data.id}`,
          response.data.id
        );

        message.success("Driver and documents uploaded successfully");
      } else {
        message.success("Driver saved successfully");
      }

      setFormData({});
      closeModal();
      refetchData(); // Trigger refetch after successful form submission
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save driver");
    }
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      style={{
        padding: "20px",
        border: "1px solid #0c8c49",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
      }}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label={<span style={{ color: "black", fontWeight: "normal"  }}>First Name</span>}
            name="firstName"
            rules={[{ required: true, message: "Please enter a first name" }]}
          >
            <Input placeholder="Enter first name" style={{ borderColor: "#0c8c49" }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={<span style={{ color: "black", fontWeight: "normal"  }}>Last Name</span>}
            name="lastName"
            rules={[{ required: true, message: "Please enter a last name" }]}
          >
            <Input placeholder="Enter last name" style={{ borderColor: "#0c8c49" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label={<span style={{ color: "black", fontWeight: "normal"  }}>Phone Number</span>}
            name="phoneNumber"
            rules={[{ required: true, message: "Please enter a phone number" }]}
          >
            <Input placeholder="Enter phone number" style={{ borderColor: "#0c8c49" }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={<span style={{ color: "black", fontWeight: "normal"  }}>Status</span>}
            name="status"
          >
            <Select placeholder="Select status" style={{ borderColor: "#0c8c49" }}>
              <Option value="Pending">Pending</Option>
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={<span style={{ color: "black", fontWeight: "normal"  }}>Upload Documents</span>}
          >
            <Upload
              onChange={handleImageFileChange}
              multiple
              listType="picture"
              fileList={imageFileList}
            >
              <Button icon={<UploadOutlined />} style={{ borderColor: "#0c8c49", color: "#0c8c49" }}>
                Upload
              </Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Row gutter={16} justify="end">
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Save
            </Button>
          </Col>
          <Col>
            <Button
              htmlType="button"
              onClick={() => form.resetFields()}
              style={{
                borderColor: "#0c8c49",
                color: "#0c8c49",
              }}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default DriversForm;
